import api from '../utils/api';

export const getWalletByUserId = async (userId) => {
  const response = await api.get(`/finance/wallets/user/${userId}`);
  return response.data;
};

export const getTransactionsByUserId = async (userId, page = 1, perPage = 10) => {
  const response = await api.get(`/finance/transactions/user/${userId}`, {
    params: { page, per_page: perPage },
  });
  return response.data;
};
export const getTransactionsByWalletId = async (walletId) => {
  const response = await api.get(`/finance/transactions/wallet/${walletId}`);
  return response.data;
};
export const getTransactionsByPlaceId = async (placeId, page = 1, perPage = 10) => {
  const response = await api.get(`/finance/transactions/place/${placeId}`, {
    params: { page, per_page: perPage },
  });
  return response.data;
};

export const getAllTransactions = async (page = 1, perPage = 10) => {
  const response = await api.get('/finance/transactions', {
    params: { page, per_page: perPage },
  });
  return response.data;
};

export const getTransactionByBookingId = async (bookingId) => {
  const response = await api.get(`/finance/transactions/booking/${bookingId}`);
  return response.data;
};

export const addCreditToWalletByUserId = async (userId, amount, description) => {
  const response = await api.post(`/finance/wallets/user/${userId}/credit`, { amount, description });
  return response.data;
};

export const addCreditToWallet = async (walletId, amount, description) => {
  console.warn("addCreditToWallet is deprecated. Use addCreditToWalletByUserId instead.");
  const response = await api.post(`/finance/wallets/${walletId}/credit`, { amount, description });
  return response.data;
};

export const updateCreditLimit = async (walletId, creditLimit) => {
  const response = await api.put(`/finance/wallets/${walletId}`, { credit_limit: creditLimit });
  return response.data;
};

export const refundTransaction = async (transactionId, description) => {
  const response = await api.post(`/finance/transactions/${transactionId}/refund`, { description });
  return response.data;
};

export const getAllWallets = async (page = 1, perPage = 10) => {
  const response = await api.get('/finance/wallets', {
    params: { page, per_page: perPage },
  });
  return response.data;
};

export const createPreference = async (amount, description, userId) => {
  const response = await api.post('/mercadopago/create_preference', {
    amount,
    description,
    user_id: userId,
  });
  return response.data;
};

export const createWompiPaymentLink = async (amount, description, userId) => {
  const response = await api.post('/wompi/create_payment_link', {
    amount,
    description,
    user_id: userId,
  });
  return response.data;
};
